/** Trigger a browser download of a blob axios response, naming the file from its
 *  Content-Disposition header (falling back to `fallbackName`). Shared by the PDF
 *  / file export client functions so the createObjectURL → anchor → revoke dance
 *  lives in one place. */
export function downloadBlobResponse(
  response: { data: BlobPart; headers?: Record<string, unknown> },
  fallbackName: string,
): void {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  const disposition = String(response.headers?.["content-disposition"] ?? "");
  const match = disposition.match(/filename="?([^"]+)"?/);
  link.download = match ? match[1] : fallbackName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
